import { fetchProjects, saveProject } from '@/api/projects'
import { t } from '@/i18n'

const state = {
        projects: [],
        projectSaveSuccess: false,
        currentProject: null,
}

const mutations = {
        SET_PROJECTS(state, projects) {
                state.projects = projects
        },
        ADD_PROJECT(state, project) {
                state.projects.push(project)
                localStorage.setItem('projects', JSON.stringify(state.projects))
        },
        UPDATE_PROJECT(state, updatedProject) {
                const index = state.projects.findIndex(p => p.id === updatedProject.id)
                if (index !== -1) {
                        state.projects.splice(index, 1, updatedProject)
                        localStorage.setItem('projects', JSON.stringify(state.projects))
                }
        },
        DELETE_PROJECT(state, projectId) {
                state.projects = state.projects.filter(p => p.id !== projectId)
                localStorage.setItem('projects', JSON.stringify(state.projects))
        },
        SET_PROJECT_SAVE_SUCCESS(state, data) {
                state.projectSaveSuccess = data.success
        },
        SET_CURRENT_PROJECT(state, project) {
                state.currentProject = project
        },
        CLEAR_CURRENT_PROJECT(state) {
                state.currentProject = null
        },
}

function encodeDump(data) {
        const json = JSON.stringify(data)
        return btoa(unescape(encodeURIComponent(json)))
}

// function decodeDump(encoded) {
//      const json = decodeURIComponent(escape(atob(encoded)));
//      return JSON.parse(json);
// }

const actions = {
        loadProjects({ commit }) {
                try {
                        const projects = localStorage.getItem('projects')
                        if (projects) {
                                commit('SET_PROJECTS', JSON.parse(projects))
                        }
                } catch (e) {
                        console.error('Error loading projects:', e)
                }
        },

        async loadProjectsFromServer({ commit }) {
                try {
                        const response = await fetchProjects()
                        commit('SET_PROJECTS', response.data)
                        return response
                } catch (error) {
                        console.error('Error loading projects:', error)
                        throw error
                }
        },

        async saveProject({ commit }, projectData) {
                try {
                        // Нормализация данных
                        const name = String(projectData.name || '').trim()
                        const images = Array.isArray(projectData.images) ? projectData.images : []

                        // Валидация
                        if (!name) throw new Error(t('Название проекта обязательно'))
                        if (images.length === 0) throw new Error(t('Добавьте элементы в проект'))

                        // Формируем проект (без id - backend его создаст)
                        const project = {
                                title: name,
                                zone_id: projectData.zoneId || 0,
                                zone_title: projectData.zoneTitle || 'Без зоны',
                                data: encodeDump(images),
                                preview: projectData.preview || '',
                        }

                        // Отправка на сервер
                        const response = await saveProject(project)

                        if (response.success) {
                                // Добавляем проект с ID из backend
                                const savedProject = {
                                        ...project,
                                        id: response.project?.id,
                                        created_at: response.project?.created_at || new Date().toISOString(),
                                }
                                commit('ADD_PROJECT', savedProject)
                                return { success: true, project: savedProject }
                        }

                        throw new Error(t('Ошибка сервера при сохранении'))
                } catch (error) {
                        console.error('Error saving project:', error)
                        throw error
                }
        },
}

const getters = {
        getProjects: state => state.projects,
        getProjectsByZone: state => zoneId =>
                state.projects
                        .filter(p => p.zoneId === zoneId)
                        .sort(
                                (a, b) =>
                                        new Date(b.updatedAt || b.createdAt) -
                                        new Date(a.updatedAt || a.createdAt)
                        ),
}

export default {
        namespaced: true,
        state,
        mutations,
        actions,
        getters,
}
